import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import Swal from "sweetalert2/dist/sweetalert2.js";
import { PdfUtil } from "../user-alarm-accident/PdfUtil";
import { MatTableDataSource } from "@angular/material/table";
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  FormGroupDirective,
  NgForm,
  Validators,
} from "@angular/forms";
import { MatMenuTrigger } from "@angular/material/menu";
import { SelectionModel } from "@angular/cdk/collections";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { TraslateService } from "src/app/traslate.service";
import { MatSnackBar } from "@angular/material/snack-bar";
import { NgxSpinnerService } from "ngx-spinner";
import { environment } from "src/environments/environment";
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import { ErrorStateMatcher } from "@angular/material/core";
import { STEPPER_GLOBAL_OPTIONS } from "@angular/cdk/stepper";
import {
  animate,
  state,
  style,
  transition,
  trigger,
} from "@angular/animations";
import { UnitsService } from "src/app/_services/units.service";

export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(
    control: FormControl | null,
    form: FormGroupDirective | NgForm | null
  ): boolean {
    const isSubmitted = form && form.submitted;
    return !!(
      control &&
      control.invalid &&
      (control.dirty || control.touched || isSubmitted)
    );
  }
}

@Component({
  selector: "app-user-alarm",
  templateUrl: "./user-alarm.component.html",
  styleUrls: ["./user-alarm.component.scss"],
})
export class UserAlarmComponent implements OnInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild("pdfTable", { static: false }) pdfTable: ElementRef;
  tableDataSource: any = [];
  pageSizeOptions = [5, 10, 25, 100];
  pageSizeOptions1: number[];
  pageSize1: any;
  collection: any;
  selection = new SelectionModel<any>(true, []);
  firstFormGroup: FormGroup;
  secondFormGroup: FormGroup;
  pageSize = 5;
  spinnerActive: boolean = true;
  highlighted = false;
  displayedColumns = [
    "select",
    "id",
    "created_by",
    "created_at",
    "updated_at",
    "action",
  ];

  dataSource = new MatTableDataSource();
  @ViewChild(MatMenuTrigger)
  contextMenu: MatMenuTrigger;
  lengthTotal: any;
  repos: any;
  url: any;
  urls: string;
  id: any;
  name: any;
  acceleration: any;
  freinage: any;
  virage_freinage: any;
  virage: any;
  virage_acceleration: any;
  exces_vitesse: any;
  franchissement_ligne: any;
  ItemSelected: any[];
  lengthItem: number;
  selectedRowIndex: any;
  selected: boolean;
  selectedRow: any;
  dialogRef: any;
  showedit: boolean;
  showadd: boolean;
  submitStatus: boolean;
  hiddenAlarm: string = "false";
  CodePostal: any;
  Nom: any;
  Groupe: any;
  lengthpage: number = 100;

  pageNum: any;
  manualPage: number = 0;
  manualPage1: number;
  createdAt: any;
  lane_crossing: string;
  created_by: string;
  speeding: string;
  turn: string;
  turn_and_accelerate: string;
  turn_and_brake: string;
  accelerationVehicule: string;
  braking: string;
  company: any;
  listAlarms: any;
  offsetPagination: any = 0;

  // ngOnInit(): void {
  // }
  exportTable() {
    Swal.fire({
      title: "Souhaitez-vous exporter la table ?",
      showCancelButton: true,
      confirmButtonColor: "#262756",
      cancelButtonColor: "#e05a61",
      confirmButtonText: "Démarrer l'exportation!",
      cancelButtonText: "Annuler",
    }).then((result) => {
      if (result.value) {
        PdfUtil.exportToPdf("ExampleTable", "tbl");
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire("Annulé", " Fichier non exporté !!");
      }
    });
  }

  supprimerAlarme(operation, id: any) {
    console.log("hereeeeeee delete alarm");
    if (operation == "oneItem") {
      this.selection.clear();
      this.ItemSelected = [];
      this.ItemSelected.push({
        id: id,
      });
      console.log("list", this.ItemSelected);
    }
    var array: any = [];
    this.ItemSelected.forEach((el) => {
      array.push(el.id);
    });
    if (array.length === 1) {
      Swal.fire({
        title: "Voulez-vous supprimer l'alarme selectionnée ?",
        showCancelButton: true,
        confirmButtonColor: "#262756",
        cancelButtonColor: "#e05a61",
        allowOutsideClick: false,
        cancelButtonText: "Annuler",
        confirmButtonText: "Oui",
      }).then((result) => {
        if (result.isConfirmed) {
          this.spinnerActive = true;
          this.spinnerAlarmAccident.show();
          this.http
            .delete(environment.apiUrl + "/alarms/" + JSON.stringify(array))
            .subscribe(
              (response: any) => {
                this.ItemSelected = [];
                this.selection.clear();
                this.lengthItem = 0;
                this.listalarm(15, 1);
                Swal.fire(response["message"]);
                this.spinnerAlarmAccident.hide();
                this.spinnerActive = false;
              },
              (error) => {
                Swal.fire({
                  text: "Un problème est survenu! " + error,
                });
                this.spinnerAlarmAccident.hide();
                this.spinnerActive = false;
              }
            );
        } else {
          this.ItemSelected = [];
          this.selection.clear();
        }
      });
    } else if (array.length >= 1) {
      Swal.fire({
        title: "Voulez-vous supprimer les alarmes sélectionnées ?",
        showCancelButton: true,
        confirmButtonColor: "#262756",
        cancelButtonColor: "#e05a61",
        allowOutsideClick: false,
        cancelButtonText: "Annuler",
        confirmButtonText: "Confirmer!",
      }).then((result) => {
        if (result.isConfirmed) {
          this.spinnerActive = true;
          this.spinnerAlarmAccident.show();
          this.http
            .delete(environment.apiUrl + "/alarms/" + JSON.stringify(array))
            .subscribe(
              (response) => {
                this.ItemSelected = [];
                this.selection.clear();
                this.lengthItem = 0;
                this.listalarm(15, 1);
                Swal.fire(response["message"]);
                this.spinnerAlarmAccident.hide();
                this.spinnerActive = false;
              },
              (error) => {
                Swal.fire({
                  text: "Un problème est survenu! " + error,
                });
                this.spinnerAlarmAccident.hide();
                this.spinnerActive = false;
              }
            );
        }
      });
    }
  }

  isAllSelected() {
    const numSelected = this.selection.selected?.length;
    const numRows = this.dataSource.data?.length;
    return numSelected === numRows;
  }

  modifierAlarme(operation, id: any, row) {
    // console.log('this.ItemSelected');
    // console.log(this.ItemSelected);

    if (operation == "oneItem") {
      this.selection.clear();
      this.ItemSelected = [];
      this.ItemSelected.push({
        id: id,
      });
    }
    if (this.ItemSelected.length === 1) {
      // this.ItemSelected = this.selection.selected
      // console.log('selection.selected');
      // console.log(this.ItemSelected);
      let dialogRef = this.dialog.open(DialogEditAlarmAccident, {
        disableClose: true,
        data: {
          animal: "panda",
        },
        width: "60%",
        height: "75%",
        panelClass: "my-custom-dialog-class",
      });
      this.traslateService.UserAlarmAccQuote.next([row]);
      dialogRef.afterClosed().subscribe((result) => {
        console.log("close dialog ");
        this.selection.clear();
      });
      for (let e of this.ItemSelected) {
        this.CodePostal = e.CodePostal;
        this.Groupe = e.Groupe;
        this.Nom = e.name;
      }
    } else if (this.ItemSelected.length >= 1) {
      Swal.fire({
        title: "Veuillez sélectionner un seul enregistrement !",
      });
    } else {
      Swal.fire({
        title: "Veuillez sélectionner un enregistrement !",
      });
    }
  }

  masterToggle() {
    this.isAllSelected()
      ? this.selection.clear()
      : this.dataSource.data.forEach((row) => {
          this.selection.select(row);
        });
  }

  checkboxLabel(row?: any): string {
    if (!row) {
      return `${this.isAllSelected() ? "select" : "deselect"} all`;
    }
    this.ItemSelected = this.selection.selected;

    //console.log(this.ItemSelected)

    return `${this.selection.isSelected(row) ? "deselect" : "select"} row ${
      row.id + 1
    }`;
  }

  getContactNotif() {
    this.lengthItem = this.selection.selected.length;
    ////console.log(' contact selected   ' + this.lengthItem)
  }

  GetSelectedRow(row) {
    if (this.selectedRowIndex === row.id) {
      this.selectedRowIndex = -1;
      this.selected = false;
    } else {
      this.selectedRow = row;
      this.selectedRowIndex = row.id;
      this.selected = true;

      //console.log("hello " + this.selectedRowIndex);
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
    localStorage.removeItem("contact1");
  }

  applyFilter(event: Event) {
    this.dataSource = new MatTableDataSource(this.tableDataSource);

    const filterValue = (event.target as HTMLInputElement).value;
    //console.log( this.dataSource)
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  public hiddencontenu2() {
    this.hiddenAlarm = "jkhjk";
  }

  constructor(
    private formBuilder: FormBuilder,
    private _snackBar: MatSnackBar,
    public dialog: MatDialog,
    private fb: FormBuilder,
    private http: HttpClient,
    public traslateService: TraslateService,
    private spinnerAlarmAccident: NgxSpinnerService
  ) {
    const headerDict = {
      "Content-Type": "application/json",
      Accept: "application/json",
      "Access-Control-Allow-Headers": "Content-Type",
    };
    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };
    //console.log(JSON.parse(localStorage.getItem('currentUser')).company_id)
    this.spinnerActive = true;
    this.spinnerAlarmAccident.show();
    this.spinnerAlarmAccident.hide();
    this.spinnerActive = false;
  }

  setPageSizeOptions(setPageSizeOptionsInput: string) {
    if (setPageSizeOptionsInput) {
      this.pageSizeOptions1 = setPageSizeOptionsInput
        .split(",")
        .map((str) => +str);
    }
  }

  registerForm: FormGroup = this.formBuilder.group({
    // tslint:disable-next-line:quotemar
    company_id: [],
    created_at: [],
    created_by: [],
    id: [],
    type: [],
    updated_at: [],
    contacts: [],
  });

  async ngOnInit(): Promise<void> {
    this.firstFormGroup = this.formBuilder.group({
      firstCtrl: ["", Validators.required],
    });
    this.secondFormGroup = this.formBuilder.group({
      secondCtrl: ["", Validators.required],
    });
    this.traslateService.UserAlarmAccdataQuote.subscribe((data) => {
      this.url = data;
    });
    this.urls = JSON.stringify(this.url);
    const headerDict = {
      "Content-Type": "application/json",
      Accept: "application/json",
      "Access-Control-Allow-Headers": "Content-Type",
    };

    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };
    this.spinnerActive = true;
    //console.log(JSON.parse(localStorage.getItem('currentUser')).company_id)
    this.http
      .get(
        environment.apiUrl +
          "/companies/" +
          JSON.parse(localStorage.getItem("currentUser")).company_id +
          "/alarms/type/2?page=1",
        requestOptions
      )
      .subscribe(
        (response: any) => {
          this.listAlarms = response?.data;
          this.lengthTotal = response.length;
          this.repos = this.listAlarms;
          this.dataSource = new MatTableDataSource(this.repos);
          //  this.dataSource.paginator = this.paginator;
          //  this.tableDataSource= this.repos;
          //  this.dataSource.sort = this.sort;
          this.listAlarms = response?.data;
          // @ts-ignore
          this.listAlarms.length = response?.total;
          this.dataSource = new MatTableDataSource(this.listAlarms);
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
          this.lengthTotal = (<any>response).total;

          this.spinnerActive = false;
        },
        (error) => {
          Swal.fire({
            text: "Un problème est survenu! " + error,
          });
          this.spinnerActive = false;
        }
      );
  }

  listalarm(currentSize, offset) {
    const headerDict = {
      "Content-Type": "application/json",
      Accept: "application/json",
      "Access-Control-Allow-Headers": "Content-Type",
    };
    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };
    this.spinnerActive = true;
    this.http
      .get(
        environment.apiUrl +
          "/companies/" +
          JSON.parse(localStorage.getItem("currentUser")).company_id +
          "/alarms/type/2" +
          "?page=" +
          offset,
        requestOptions
      )
      .subscribe(
        (response: any) => {
          this.listAlarms = response.data;
          this.lengthTotal = this.listAlarms.total;
          this.repos = this.listAlarms;
          console.log("fatiha", this.repos);
          this.dataSource = new MatTableDataSource(this.repos);
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
          this.lengthTotal = this.listAlarms.total;
          this.spinnerActive = false;
        },
        (error) => {
          Swal.fire({
            text: "Un problème est survenu! " + error,
          });
          this.spinnerActive = false;
        }
      );
  }

  pageChanged(event) {
    let pageIndex = event.pageIndex;
    let pageSize = event.pageSize;

    let previousIndex = event.previousPageIndex;

    let previousSize = pageSize * pageIndex;
    console.log("previousSize", previousSize);
    console.log("pageIndex", pageIndex);
    console.log("pageSize", pageSize);
    this.getNextData(previousSize, pageIndex.toString(), pageSize.toString());
  }

  getNextData(currentSize, offset, limit) {
    const headerDict = {
      "Content-Type": "application/json",
      Accept: "application/json",
      "Access-Control-Allow-Headers": "Content-Type",
    };
    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };
    //this.alarmHistory = true;
    this.offsetPagination = parseInt(offset) + 1;
    this.http
      .get(
        environment.apiUrl +
          "/companies/" +
          JSON.parse(localStorage.getItem("currentUser")).company_id +
          "/alarms/type/2" +
          "?page=" +
          offset,
        requestOptions
      )
      .subscribe((response) => {
        // @ts-ignore
        console.log("page", response);
        // @ts-ignore
        this.repos.length = currentSize;
        // @ts-ignore
        this.repos.push(...response.data);
        // @ts-ignore
        this.repos.length = response.total;
        //this.alarmHistory = false;
        this.dataSource = new MatTableDataSource<any>(this.repos);
        this.dataSource._updateChangeSubscription();
        this.dataSource.paginator = this.paginator;
      });
  }

  openDialog() {
    this.dialog.open(DialogAddAlarmAccident, {
      disableClose: true,
      data: {
        animal: "panda",
      },
      width: "60%",
      height: "75%",
      panelClass: "my-custom-dialog-class",
    });
  }

  openDialogAddEvent() {
    this.dialog.open(DialogAddAlarmEv, {
      disableClose: true,
      data: {
        animal: "panda",
      },
      width: "70%",
      height: "90%",
      panelClass: "my-custom-dialog-class",
    });
  }

  modif_cancel() {
    this.registerForm.reset();
  }

  // openDialog(addAlarm){
  //   this.showedit = false;
  //   this.showadd = true;
  //   //console.log('showedit   '+this.showedit)
  //   //console.log('showadd    '+this.showadd)
  //   this.modif_cancel();
  //   this.dialog.open(addAlarm,{
  //     height:'510px',
  //     width:'700px'
  //   })
  // }
  hiddencontenu() {
    this.hiddenAlarm = "true";
  }
  //ev
  submitForm() {
    Object.values(this.registerForm).forEach((val) => {
      //console.log(val);
    });
    this.submitStatus = true;
    this.http
      .post(
        environment.apiUrl +
          "/companies/" +
          JSON.parse(localStorage.getItem("currentUser")).company_id +
          "/alarms/type/2",
        this.registerForm.value
      )
      .subscribe(
        (data) => {
          //console.log(data)
          var statuscontact: any = data;
          if (statuscontact.status == 200) {
            Swal.fire({
              position: "center",
              title: "Alarme ajoutée avec succées !",
              showConfirmButton: false,
              timer: 2000,
            });
            location.reload();
          } else {
            //console.log('500 status')
            Swal.fire({
              text: statuscontact.response + "!",
            });
          }
        },
        (error) => {
          Swal.fire({
            text: "Un problème est survenu! " + error,
          });
        }
      );
    //location.reload()
  }

  exportExcel(e, e2) {
    Swal.fire({
      title: "Souhaitez-vous exporter la table ?",
      showCancelButton: true,
      confirmButtonColor: "#262756",
      cancelButtonColor: "#e05a61",
      confirmButtonText: "Démarrer l'exportation!",
      cancelButtonText: "Annuler",
    }).then((result) => {
      if (result.value) {
        Swal.fire("Export!", "Le fichier est exporté.");
        //console.log(e);
        e.exportTable(e2, {
          fileName: "STG_DRIVE_vehicule_date_" + new Date().toLocaleString(),
          sheet: "STG DRIVE Vehicule",
          Props: { Author: "STG_DRIVE" },
        });
      } else if (result.dismiss === Swal.DismissReason.cPDFfileancel) {
        Swal.fire("Annuler", "Fichier non exporté !!");
      }
    });
  }

  public updateManualPage2(index2) {
    this.collection = [];

    //console.log(this.pageSizeOptions1)
    this.paginator.pageSize = index2;

    this.paginator.page.next({
      pageIndex: this.paginator.pageIndex,
      pageSize: index2,
      length: this.paginator.length,
    });
    //console.log('jjjj')

    this.lengthpage = parseInt("" + this.paginator.length / index2);

    //console.log(this.lengthpage)

    //Create dummy data
    for (var i = 0; i < this.lengthpage; i++) {
      this.collection.push(i + 1);
    }

    //console.log(this.collection)
  }

  public updateManualPage(index): void {
    //console.log(index)
    this.pageNum = index;
    this.manualPage = index;
    this.paginator.pageIndex = index;

    this.paginator.page.next({
      pageIndex: this.paginator.pageIndex,
      pageSize: this.paginator.pageSize,
      length: this.paginator.length,
    });
  }

  async afficher_info(row) {
    if (this.ItemSelected.length == 0) {
      this.ItemSelected.push(row);
    }
    if (this.ItemSelected.length === 1) {
      for (let e of this.ItemSelected) {
        this.Nom = e.created_by;
        this.company = e.company;
        this.createdAt = e.created_at;
      }
      const { value: formValues } = await Swal.fire({
        border: " 1px solid #262853",
        width: 900,
        opacity: 1,
        background: "rgba(238,238,238,0)",
        showConfirmButton: false,
        html:
          '<div style="background: rgba(255, 255, 255, 0.8);border-radius: 16px;box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);backdrop-filter: blur(13.7px);' +
          '-webkit-backdrop-filter: blur(8px);border: 1px solid rgba(255, 255, 255, 0.22);  border: 1px solid #262853;border-radius: 25px;">' +
          "<div>" +
          '<h1 class="pb-4" style="color :#262756;margin-right: 55%;margin-top: 5%;" > <strong>  Détails d\'alarme </strong> <h1>' +
          "</div>" +
          '<table class="swal" style="color :#262756;margin-left: 15%; text-align: left; margin-bottom: 10%;">' +
          ' <tr style="height: 24px !important;" ><td><h2 style="font-size: 15px;padding:0px; margin:0px;">Créé par : </h2></td><td><h3 style="font-size: 15px; padding:0px; margin:0px;"> ' +
          this.Nom +
          "</h3></td></tr>" +
          ' <tr style="height: 14px !important;"><td><h2 style="font-size: 15px; padding:0px; margin:0px;">Compagnie : </h2></td><td><h3 style="font-size: 15px; padding:0px; margin:0px;"> ' +
          this.company +
          "</h3></td></tr>" +
          ' <tr style="height: 4px !important;"><td><h2 style="font-size: 15px; padding:0px; margin:0px;">Date de création : </h2></td><td><h3 style="font-size: 15px; padding:0px; margin:0px;"> ' +
          new Date(this.createdAt).toLocaleString() +
          "</h3></td></tr>" +
          "</table>" +
          "</div>",
      }).then((result) => {
        if (result.isConfirmed) {
          // console.log('isConfirmed isConfirmed');
        } else {
          // console.log('else else');
          this.ItemSelected = [];
          this.selection.clear();
        }
      });
    } else if (this.ItemSelected.length >= 1) {
      Swal.fire({
        title: "Veuillez selectionner un seul enregistrement ",
      });
    } else {
      Swal.fire({
        title: "Veuillez selectionner un enregistrement",
      });
    }
  }
}

@Component({
  selector: "dialog-elements-example-dialog",
  styleUrls: ["./user-alarm.component.scss"],
  templateUrl: "AddAlarmAcc.html",
  providers: [
    {
      provide: STEPPER_GLOBAL_OPTIONS,
      useValue: { displayDefaultIndicatorType: true },
    },
  ],
})
export class DialogAddAlarmAccident implements OnInit {
  firstFormGroup: FormGroup;
  secondFormGroup: FormGroup;
  accelerationinput: boolean = false;
  bosseinput: boolean = false;
  hors_pisteinput: boolean = false;
  franch_de_ligne_input: boolean = false;
  excesvitesseinput: boolean = false;
  freinageinput: boolean = false;
  vir_accelerationinput: boolean = false;
  vir_frein_input: boolean = false;
  virageinput: boolean = false;
  alarmActive: boolean;
  alarmtranche: boolean;
  name: any;
  entry: any;
  submitStatus: boolean;
  url: any;
  acceleration: any;
  freinage: any;
  virage: any;
  virage_freinage: any;
  exces_vitesse: any;
  virage_acceleration: any;
  franchissement_ligne: any;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild("secondPaginator", { static: true }) secondPaginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  tableDataSourceContact: any = [];
  selection = new SelectionModel<any>(true, []);
  selectedRow;
  selected: boolean;
  ItemSelected: any[];
  arr: any = [];
  repos: any;
  entryC: any;
  lengthTotal: any;
  displayedColumns: string[] = [
    "id",
    "first_name",
    "last_name",
    "email",
    "delete",
  ];
  dataSource = new MatTableDataSource();
  matcher = new MyErrorStateMatcher();
  contacts = new FormControl();
  contactList: any = "";
  new_contact: boolean;
  urlC: any;
  id: any;
  first_name: any;
  last_name: any;
  gsm: any;
  email: any;
  lengthItem: any = null;
  selectedRowIndex: number = -1;
  hiddenContact: string = "false";
  dataSourcet: any;
  myControl = new FormControl();
  selectedRowIndex2 = -1;
  displayedColumnst: string[] = ["position"];
  itemSelect2: any;
  contact_notif: any = [];
  dataSourceC = new MatTableDataSource();
  urls: any;
  contact_notif2: any = [];
  level: any = 1;

  getItemDetails2(e) {
    this.itemSelect2 = e.id;
    this.first_name = e.first_name;
    this.last_name = e.last_name;
    this.email = e.email;
    if (!this.contact_notif.some((item) => item.id == e.id)) {
      this.contact_notif.push(e);
      this.contact_notif2.push(e.id);
      this.selectedRowIndex2 = e.id;
      this.hiddenContact = "jkhjk";
      localStorage.setItem("contact1", this.contact_notif2);
      var ids = localStorage.getItem("contact1");
      var ids2 = ids.split(",");
      var test = "test";
      this.registerForm.setControl(
        "contacts",
        new FormControl(JSON.stringify(ids2))
      );
    } else {
      Swal.fire({
        position: "center",
        title: "Contact déjà selectionné !",
        text: "Veillez selectionner un autre contact à notifier !",
        showConfirmButton: false,
        timer: 4000,
      });
    }
  }

  getContact_notif() {
    this.dataSourceC = new MatTableDataSource(this.contact_notif);
  }

  constructor(
    public dialogRef: MatDialogRef<DialogAddAlarmAccident>,
    private _formBuilder: FormBuilder,
    public traslateService: TraslateService,
    private http: HttpClient,
    private formBuilder: FormBuilder,
    private _snackBar: MatSnackBar,
    private spinnerAlarmAccident: NgxSpinnerService
  ) {
    this.getContactSelect();
    const headerDict = {
      "Content-Type": "application/json",
      Accept: "application/json",
      "Access-Control-Allow-Headers": "Content-Type",
    };
    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };
    this.http
      .get(
        environment.apiUrl +
          "/companies/" +
          JSON.parse(localStorage.getItem("currentUser")).company_id +
          "/contacts/all",
        requestOptions
      )
      .subscribe(
        (response) => {
          var listContacts: any = response;
          this.lengthTotal = listContacts.length;
          this.repos = listContacts;
          this.dataSource = new MatTableDataSource(this.repos);
          this.dataSource.paginator = this.paginator;
          this.tableDataSourceContact = this.repos;
          this.dataSource.sort = this.sort;
        },
        (error) => {
          Swal.fire({
            text: "Un problème est survenu! " + error,
          });
        }
      );
  }

  setEntityIDVEh(event) {
    console.log("entity_id", event.id);
    this.registerForm.setControl("entity_id", new FormControl(event.id));
  }

  hiddencontenu() {
    this.hiddenContact = "true";
  }

  applyFilter1(event: Event) {
    const filterValue2 = (event.target as HTMLInputElement).value;
    this.dataSourcet.filter = filterValue2.trim().toLowerCase();
    if (this.dataSourcet.paginator) {
      this.dataSourcet.paginator.firstPage();
    }
    this.hiddenContact = "true";
  }

  public hiddencontenu2() {
    this.hiddenContact = "jkhjk";
  }

  async refrech() {
    const headerDict = {
      "Content-Type": "application/json",
      Accept: "application/json",
      "Access-Control-Allow-Headers": "Content-Type",
    };
    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };

    this.http
      .get(
        environment.apiUrl +
          "/companies/" +
          JSON.parse(localStorage.getItem("currentUser")).company_id +
          "/contacts/all",
        requestOptions
      )
      .subscribe(
        (response) => {
          this.contactList = response;
          this.dataSourcet = new MatTableDataSource(this.contactList);
          this.dataSourcet.paginator = this.secondPaginator;
          this._snackBar.open(
            "la liste des contacts est actualisée ",
            "Fermer",
            {
              duration: 2500,
            }
          );
        },
        (error) => {
          Swal.fire({
            text: "Un problème est survenu! " + error,
          });
        }
      );
  }

  getContactSelect() {
    const headerDict = {
      "Content-Type": "application/json",
      Accept: "application/json",
      "Access-Control-Allow-Headers": "Content-Type",
    };
    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };
    this.http
      .get(
        environment.apiUrl +
          "/companies/" +
          JSON.parse(localStorage.getItem("currentUser")).company_id +
          "/contacts/all",
        requestOptions
      )
      .subscribe(
        (response) => {
          this.contactList = response;
          this.dataSourcet = new MatTableDataSource(this.contactList);
          this.dataSourcet.paginator = this.secondPaginator;
        },
        (error) => {
          Swal.fire({
            text: "Un problème est survenu! " + error,
          });
        }
      );
  }

  registerForm: FormGroup = this.formBuilder.group({
    // tslint:disable-next-line:quotemar
    company_id: [],
    created_at: [],
    created_by: [],
    id: [],
    type: [],
    updated_at: [],
    contacts: [],
    level: 1,
    entity_id: [],
  });

  async ngOnInit(): Promise<void> {
    this.name = JSON.parse(localStorage.getItem("currentUser")).company;
    this.traslateService.UserAlarmAccdataQuote.subscribe((data) => {
      this.url = data;
    });
    this.urls = JSON.stringify(this.url);
    for (let entry of this.urls) {
      this.id = entry.id;
      this.first_name = entry.first_name;
      this.last_name = entry.last_name;
      this.gsm = entry.gsm_number;
      this.email = entry.email;
    }

    this.firstFormGroup = this._formBuilder.group({
      firstCtrl: ["", Validators.required],
    });
    this.secondFormGroup = this._formBuilder.group({
      secondCtrl: ["", Validators.required],
    });
    this.getContactSelect();
  }

  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    const numSelected = this.selection.selected?.length;
    const numRows = this.dataSource.data?.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected()
      ? this.selection.clear()
      : this.dataSource.data.forEach((row) => {
          this.selection.select(row);
        });
  }

  /** The label for the checkbox on the passed row */
  checkboxLabel(row?: any): string {
    if (!row) {
      return `${this.isAllSelected() ? "select" : "deselect"} all`;
    }
    this.ItemSelected = this.selection.selected;
    return `${this.selection.isSelected(row) ? "deselect" : "select"} row ${
      row.id + 1
    }`;
  }

  getContactNotif() {
    this.lengthItem = this.selection.selected.length;
  }

  GetSelectedRow(row) {
    if (this.selectedRowIndex === row.id) {
      this.selectedRowIndex = -1;
      this.selected = false;
    } else {
      this.selectedRow = row;
      this.selectedRowIndex = row.id;
      this.selected = true;
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
    localStorage.removeItem("contact1");
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  registerFormContact: FormGroup = this.formBuilder.group({
    // tslint:disable-next-line:quotemar
    last_name: [
      "",
      {
        validators: [
          Validators.required,
          Validators.pattern(/^[a-zA-Z][a-zA-Z\s]+$/),
        ],
        updateOn: "change",
      },
    ],
    email: [
      "",
      {
        validators: [Validators.required, Validators.email],
        updateOn: "change",
      },
    ],

    gsm_number: [],
    first_name: [
      "",
      {
        validators: [
          Validators.required,
          Validators.pattern(/^[a-zA-Z][a-zA-Z\s]+$/),
        ],
        updateOn: "change",
      },
    ],
    company_id: [],
    created_at: [],
    created_by: [],
    id: [],
    updated_at: [],
  });

  add_contact() {
    this.new_contact = !this.new_contact;
  }

  submitcontact() {
    if (this.registerFormContact.invalid) {
      return;
    }
    Object.values(this.registerFormContact).forEach((val) => {});
    this.submitStatus = true;
    this.http
      .post(
        environment.apiUrl +
          "/companies/" +
          JSON.parse(localStorage.getItem("currentUser")).company_id +
          "/contacts/all",
        this.registerFormContact.value
      )
      .subscribe(
        (data) => {
          var statuscontact: any = data;
          if (statuscontact.status == 200) {
            Swal.fire({
              position: "center",
              title: "Contact ajouté avec succées !",
              showConfirmButton: false,
              timer: 4000,
            });
            this.getContactSelect();
            this.registerFormContact.reset();
          } else {
            Swal.fire({
              text: statuscontact.message + "!",
            });
          }
        },
        (error) => {
          Swal.fire({
            text: "Un problème est survenu! " + error,
          });
        }
      );
  }

  Delete_contact(e) {
    this.getContact_notif();
    localStorage.removeItem("contact1");
    this.contact_notif.splice(e, 1);
    this.contact_notif2.splice(e, 1);
    localStorage.setItem("contact1", this.contact_notif2);
    var ids = localStorage.getItem("contact1");
    var ids2 = ids.split(",");
    this.registerForm.setControl(
      "contacts",
      new FormControl(JSON.stringify(ids2))
    );
  }

  select_contact() {
    this.new_contact = false;
  }
  //acc
  submitForm() {
    console.log("this.registerForm //", this.registerForm.value, this.level);
    if (this.registerForm.get("level").value === 1)
      this.registerForm.setControl(
        "entity_id",
        new FormControl(
          JSON.parse(localStorage.getItem("currentUser")).company_id
        )
      );

    console.log("this.registerForm", this.registerForm.value);
    Object.values(this.registerForm).forEach((val) => {});
    this.submitStatus = true;

    this.http
      .post(
        environment.apiUrl +
          "/companies/" +
          JSON.parse(localStorage.getItem("currentUser")).company_id +
          "/alarms/type/2",
        this.registerForm.value
      )
      .subscribe(
        (data) => {
          var statuscontact: any = data;
          if (statuscontact.status == 200) {
            Swal.fire({
              position: "center",
              title: "Alarme ajoutée avec succées !",
              showConfirmButton: false,
              timer: 2000,
            });
            location.reload();
          } else {
            Swal.fire({
              text: statuscontact.response + "!",
            });
          }
        },
        (error) => {
          Swal.fire({
            text: "Un problème est survenu! " + error,
          });
        }
      );

    //location.reload()
  }

  enableacceleration() {
    this.accelerationinput = !this.accelerationinput;
  }

  enablevirage() {
    this.virageinput = !this.virageinput;
  }

  enablevir_frein() {
    this.vir_frein_input = !this.vir_frein_input;
  }

  enableexcesvitesse() {
    this.excesvitesseinput = !this.excesvitesseinput;
  }

  enableFreinage() {
    this.freinageinput = !this.freinageinput;
  }

  enable_vir_acceleration() {
    this.vir_accelerationinput = !this.vir_accelerationinput;
  }

  enable_franch_de_ligne() {
    this.franch_de_ligne_input = !this.franch_de_ligne_input;
  }

  enablehors_piste() {
    this.hors_pisteinput = !this.hors_pisteinput;
  }

  enablebosse() {
    this.bosseinput = !this.bosseinput;
  }

  alarm_active_tranches() {
    this.alarmtranche = true;
  }

  alarm_tjrs_active() {
    this.alarmtranche = false;
  }
}

@Component({
  selector: "dialog-elements-example-dialog",
  styleUrls: ["./user-alarm.component.scss"],
  templateUrl: "EditAlarmAcc.html",
  providers: [
    {
      provide: STEPPER_GLOBAL_OPTIONS,
      useValue: { displayDefaultIndicatorType: true },
    },
  ],
})
export class DialogEditAlarmAccident implements OnInit {
  firstFormGroup: FormGroup;
  secondFormGroup: FormGroup;

  accelerationinput: boolean = false;
  bosseinput: boolean = false;
  hors_pisteinput: boolean = false;
  franch_de_ligne_input: boolean = false;
  excesvitesseinput: boolean = false;
  freinageinput: boolean = false;
  vir_accelerationinput: boolean = false;
  vir_frein_input: boolean = false;
  virageinput: boolean = false;
  alarmActive: boolean;
  alarmtranche: boolean;
  url: any;
  name: any;

  acceleration: any;
  freinage: any;
  virage: any;
  virage_freinage: any;
  exces_vitesse: any;
  virage_acceleration: any;
  franchissement_ligne: any;
  submitStatus: boolean;
  id: any;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild("secondPaginator", { static: true }) secondPaginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  tableDataSourceContact: any = [];
  selection = new SelectionModel<any>(true, []);
  selectedRow;
  selected: boolean;
  ItemSelected: any[];
  arr: any = [];
  repos: any;
  entryC: any;
  lengthTotal: any;
  hiddenContact: string = "false";

  displayedColumns: string[] = [
    "id",
    "first_name",
    "last_name",
    "email",
    "delete",
  ];
  dataSource = new MatTableDataSource();
  contacts = new FormControl();
  contactList: any = "";
  new_contact: boolean;

  matcher = new MyErrorStateMatcher();

  urlC: any;
  idC: any;
  first_name: any;
  last_name: any;
  gsm: any;
  email: any;
  compagnie: any;
  lengthItem: any = null;
  selectedRowIndex: number = -1;

  dataSourcet: any;
  myControl = new FormControl();
  selectedRowIndex2 = -1;
  displayedColumnst: string[] = ["position"];
  itemSelect2: any;
  contact_notif: any = [];
  dataSourceC = new MatTableDataSource();

  contactList1: any = [];
  contact_notif1: any = [];
  contact_notif2: any = [];
  level: any;
  entity_id: any;
  company_id: any;
  selectedUnit: any = { name: "" };

  setEntityIDVEh(event) {
    console.log("entity_id", event.id);
    this.registerForm2.setControl("entity_id", new FormControl(event.id));
  }

  getItemDetails2(e) {
    this.itemSelect2 = e.id;
    this.first_name = e.first_name;
    this.last_name = e.last_name;
    this.email = e.email;
    if (!this.contact_notif.some((item) => item.id == e.id)) {
      this.contact_notif.push(e);
      this.contact_notif2.push(e.id);
      this.hiddenContact = "jkhjk";
      localStorage.setItem("contact1", this.contact_notif2);
      var ids = localStorage.getItem("contact1");
      var ids2 = ids.split(",");
      this.registerForm2.setControl(
        "contacts",
        new FormControl(JSON.stringify(ids2))
      );
    } else {
      Swal.fire({
        position: "center",
        title: "Contact déjà selectionné !",
        text: "Veillez selectionner un autre contact à notifier !",
        showConfirmButton: false,
        timer: 4000,
      });
    }

    // this.contact_notif.push(e);
    //console.log( this.contact_notif)
  }

  getContact_notif() {
    this.dataSourceC = new MatTableDataSource(this.contact_notif);
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  constructor(
    public dialogRef: MatDialogRef<DialogEditAlarmAccident>,
    private units: UnitsService,
    public traslateService: TraslateService,
    private _formBuilder: FormBuilder,
    private http: HttpClient,
    private formBuilder: FormBuilder,
    private _snackBar: MatSnackBar,
    private spinnerAlarmAccident: NgxSpinnerService
  ) {
    this.traslateService.UserAlarmAccdataQuote.subscribe((data) => {
      this.url = data;
    });
    this.getContactSelect();
    const headerDict = {
      "Content-Type": "application/json",
      Accept: "application/json",
      "Access-Control-Allow-Headers": "Content-Type",
    };

    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };
    this.http
      .get(
        environment.apiUrl +
          "/companies/" +
          JSON.parse(localStorage.getItem("currentUser")).company_id +
          "/contacts/all",
        requestOptions
      )
      .subscribe(
        (response) => {
          var listContacts: any = response;
          this.lengthTotal = listContacts.length;
          this.repos = listContacts;
          this.dataSource = new MatTableDataSource(this.repos);
          this.dataSource.paginator = this.paginator;
          this.tableDataSourceContact = this.repos;
          this.dataSource.sort = this.sort;
        },
        (error) => {
          Swal.fire({
            text: "Un problème est survenu! " + error,
          });
        }
      );
  }

  hiddencontenu() {
    this.hiddenContact = "true";
  }

  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    const numSelected = this.selection.selected?.length;
    const numRows = this.dataSource.data?.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected()
      ? this.selection.clear()
      : this.dataSource.data.forEach((row) => {
          this.selection.select(row);
        });
  }

  /** The label for the checkbox on the passed row */
  checkboxLabel(row?: any): string {
    if (!row) {
      return `${this.isAllSelected() ? "select" : "deselect"} all`;
    }
    this.ItemSelected = this.selection.selected;
    return `${this.selection.isSelected(row) ? "deselect" : "select"} row ${
      row.id + 1
    }`;
  }

  getContactNotif() {
    this.lengthItem = this.selection.selected.length;
  }

  GetSelectedRow(row) {
    if (this.selectedRowIndex === row.id) {
      this.selectedRowIndex = -1;
      this.selected = false;
    } else {
      this.selectedRow = row;
      this.selectedRowIndex = row.id;
      this.selected = true;
    }
  }

  applyFilter1(event: Event) {
    const filterValue2 = (event.target as HTMLInputElement).value;
    this.dataSourcet.filter = filterValue2.trim().toLowerCase();
    if (this.dataSourcet.paginator) {
      this.dataSourcet.paginator.firstPage();
    }
    this.hiddenContact = "true";
  }
  public hiddencontenu2() {
    this.hiddenContact = "jkhjk";
  }

  async refrech() {
    const headerDict = {
      "Content-Type": "application/json",
      Accept: "application/json",
      "Access-Control-Allow-Headers": "Content-Type",
    };
    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };
    this.http
      .get(
        environment.apiUrl +
          "/companies/" +
          JSON.parse(localStorage.getItem("currentUser")).company_id +
          "/contacts/all",
        requestOptions
      )
      .subscribe(
        (response) => {
          this.contactList = response;
          this.dataSourcet = new MatTableDataSource(this.contactList);
          this.dataSourcet.paginator = this.secondPaginator;
          this._snackBar.open(
            "la liste des contacts est actualisée ",
            "Fermer",
            {
              duration: 2500,
            }
          );
        },
        (error) => {
          Swal.fire({
            text: "Un problème est survenu! " + error,
          });
        }
      );
  }

  getContactSelect() {
    const headerDict = {
      "Content-Type": "application/json",
      Accept: "application/json",
      "Access-Control-Allow-Headers": "Content-Type",
    };
    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };
    this.http
      .get(
        environment.apiUrl +
          "/companies/" +
          JSON.parse(localStorage.getItem("currentUser")).company_id +
          "/contacts/all",
        requestOptions
      )
      .subscribe(
        (response) => {
          this.contactList = response;
          this.dataSourcet = new MatTableDataSource(this.contactList);
          this.dataSourcet.paginator = this.secondPaginator;
        },
        (error) => {
          Swal.fire({
            text: "Un problème est survenu! " + error,
          });
        }
      );
  }

  getContactsN(e) {
    const headerDict = {
      "Content-Type": "application/json",
      Accept: "application/json",
      "Access-Control-Allow-Headers": "Content-Type",
    };
    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };
    this.http
      .get(
        environment.apiUrl +
          "/companies/" +
          JSON.parse(localStorage.getItem("currentUser")).company_id +
          "/contacts/all",
        requestOptions
      )
      .subscribe(
        (response: any) => {
          this.contactList1 = response;
          console.log("contact_notif1", this.contact_notif1, this.contactList1);
          for (let i of JSON.parse(e.contacts)) {
            for (let element of this.contactList1) {
              if (element.id === i) {
                this.contact_notif.push(element);
                this.contact_notif2.push(element.id);
                localStorage.setItem("contact1", this.contact_notif2);
              }
            }
          }
          this.dataSourceC = new MatTableDataSource(this.contact_notif);
        },
        (error) => {
          Swal.fire({
            text: "Un problème est survenu! " + error,
          });
        }
      );
  }

  async ngOnInit() {
    this.traslateService.UserAlarmAccdataQuote.subscribe((data) => {
      this.url = data;
      console.log("*****", data);
    });

    for (let entry of this.url) {
      this.id = entry.id;
      this.level = entry.level;
      this.entity_id = entry.entity_id;
      this.name = entry.company;
      this.acceleration = entry.acceleration;
      this.freinage = entry.braking;
      this.virage = entry.turn;
      this.virage_freinage = entry.turn_and_brake;
      this.virage_acceleration = entry.turn_and_accelerate;
      this.exces_vitesse = entry.speeding;
      this.franchissement_ligne = entry.lane_crossing;
      this.company_id = entry.company_id;
      this.getContactsN(entry);
    }
    console.log("level", this.level);

    //acc
    if (this.level == 0)
      (await this.units.getAllUnits(this.company_id)).subscribe(
        (response: any) => {
          let units = response.vehicles;
          this.selectedUnit = units.find((c) => c.id === this.entity_id);
          console.log("selectedUnitqcc", this.selectedUnit, response);
        }
      );
    this.traslateService.UserAlarmAccdataQuote.subscribe((data) => {
      this.urlC = data;
    });

    for (let entry of this.url) {
      this.id = entry.id;
      this.first_name = entry.first_name;
      this.last_name = entry.last_name;
      this.gsm = entry.gsm_number;
      this.email = entry.email;
    }

    this.firstFormGroup = this._formBuilder.group({
      firstCtrl: ["", Validators.required],
    });
    this.secondFormGroup = this._formBuilder.group({
      secondCtrl: ["", Validators.required],
    });

    this.getContactSelect();
  }

  registerForm2: FormGroup = this.formBuilder.group({
    // tslint:disable-next-line:quotemar
    company: [],
    company_id: [],
    created_at: [],
    created_by: [],
    id: [],
    level: [],
    entity_id: [],
    type: [],
    updated_at: [],
    contacts: [],
  });

  registerFormContact: FormGroup = this.formBuilder.group({
    // tslint:disable-next-line:quotemar
    last_name: [
      "",
      {
        validators: [
          Validators.required,
          Validators.pattern(/^[a-zA-Z][a-zA-Z\s]+$/),
        ],
        updateOn: "change",
      },
    ],
    email: [
      "",
      {
        validators: [Validators.required, Validators.email],
        updateOn: "change",
      },
    ],
    gsm_number: [],
    first_name: [
      "",
      {
        validators: [
          Validators.required,
          Validators.pattern(/^[a-zA-Z][a-zA-Z\s]+$/),
        ],
        updateOn: "change",
      },
    ],
    company_id: [],
    created_at: [],
    created_by: [],
    id: [],
    updated_at: [],
  });

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  add_contact() {
    this.new_contact = !this.new_contact;
  }

  select_contact() {
    this.new_contact = false;
  }

  submitcontact() {
    if (this.registerFormContact.invalid) {
      return;
    }
    Object.values(this.registerFormContact).forEach((val) => {});
    this.submitStatus = true;

    this.http
      .post(
        environment.apiUrl +
          "/companies/" +
          JSON.parse(localStorage.getItem("currentUser")).company_id +
          "/contacts/all",
        this.registerFormContact.value
      )
      .subscribe(
        (data) => {
          var statuscontact: any = data;
          if (statuscontact.status == 200) {
            Swal.fire({
              position: "center",
              title: "Contact ajouté avec succées !",
              showConfirmButton: false,
              timer: 4000,
            });
            this.getContactSelect();
            this.registerFormContact.reset();
          } else {
            //console.log('500 status')
            Swal.fire({
              text: statuscontact.message + "!",
            });
          }
        },
        (error) => {
          Swal.fire({
            text: "Un problème est survenu! " + error,
          });
        }
      );
    //location.reload()
  }

  Delete_contact(e) {
    this.getContact_notif();
    localStorage.removeItem("contact1");
    this.contact_notif.splice(e, 1);
    this.contact_notif2.splice(e, 1);
    localStorage.setItem("contact1", this.contact_notif2);
    var ids = localStorage.getItem("contact1");
    var ids2 = ids.split(",");
    this.registerForm2.setControl(
      "contacts",
      new FormControl(JSON.stringify(ids2))
    );
  }

  submitFormupdate() {
    Object.values(this.registerForm2).forEach((val) => {});
    this.submitStatus = true;
    this.http
      .put(environment.apiUrl + "/alarms/" + this.id, this.registerForm2.value)
      .subscribe(
        (data) => {
          var statuscontact: any = data;
          if (statuscontact.status == 200) {
            Swal.fire({
              position: "center",
              title: "Modification enregistrée avec succées !",
              showConfirmButton: false,
              timer: 2000,
            });
            location.reload();
          } else {
            Swal.fire({
              text: statuscontact.response + "!",
            });
          }
        },
        (error) => {
          Swal.fire({
            text: "Un problème est survenu! " + error,
          });
        }
      );
  }
  click() {
    this.compagnie = this.compagnie.name;
  }

  enableacceleration() {
    this.accelerationinput = !this.accelerationinput;
  }

  enablevirage() {
    this.virageinput = !this.virageinput;
  }

  enablevir_frein() {
    this.vir_frein_input = !this.vir_frein_input;
  }

  enableexcesvitesse() {
    this.excesvitesseinput = !this.excesvitesseinput;
  }

  enableFreinage() {
    this.freinageinput = !this.freinageinput;
  }

  enable_vir_acceleration() {
    this.vir_accelerationinput = !this.vir_accelerationinput;
  }

  enable_franch_de_ligne() {
    this.franch_de_ligne_input = !this.franch_de_ligne_input;
  }

  enablehors_piste() {
    this.hors_pisteinput = !this.hors_pisteinput;
  }

  enablebosse() {
    this.bosseinput = !this.bosseinput;
  }

  alarm_active_tranches() {
    this.alarmtranche = true;
  }

  alarm_tjrs_active() {
    this.alarmtranche = false;
  }

  onNoClick(): void {
    this.dialogRef.close();
    localStorage.removeItem("contact1");
  }
}

@Component({
  selector: "listeAlarmEvents",
  templateUrl: "listeAlarmEvent.html",
  styleUrls: ["./user-alarm.component.scss"],
  animations: [
    trigger("detailExpand", [
      state("collapsed", style({ height: "0px", minHeight: "0" })),
      state("expanded", style({ height: "*" })),
      transition(
        "expanded <=> collapsed",
        animate("225ms cubic-bezier(0.4, 0.0, 0.2, 1)")
      ),
    ]),
  ],
})
export class UserAlarmEventsListeComponent implements OnInit {
  expandedElement: any | null;

  @ViewChild("paginator", { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild("pdfTable", { static: false }) pdfTable: ElementRef;

  tableDataSource: any = [];

  collection: any = [];
  lengthpage: number = 100;
  pageSizeOptions1: number[];
  pageNum: any;
  manualPage: number = 0;

  manualPage1: number;
  public currentPage = 0;
  public totalSize = 0;
  pageSizeOptions = [5, 10, 25];
  pageSize1: any;
  pageSize = 10;
  index2: any = 10;
  selection = new SelectionModel<any>(true, []);
  selectedRow;
  selected: boolean = false;
  ItemSelected: any[] = [];
  hi: any;
  firstFormGroup: FormGroup;
  secondFormGroup: FormGroup;

  arr: any = [];

  highlighted = false;
  selectedRowIndex: number = -1;

  displayedColumns = [
    "select",
    "id",
    "created_by",
    "created_at",
    "updated_at",
    "action",
  ];
  dataSourceev = new MatTableDataSource();

  @ViewChild(MatMenuTrigger)
  contextMenu: MatMenuTrigger;

  contextMenuPosition = { x: "0px", y: "0px" };
  CodePostal: any;
  Nom: any;
  Groupe: any;
  lengthTotal: any;
  Itemss: any;
  repos: any;
  entry: any;
  submitStatus: boolean;
  url: any = [];
  name: any;
  acceleration: any;
  freinage: any;
  virage: any;
  virage_freinage: any;
  exces_vitesse: any;
  virage_acceleration: any;
  franchissement_ligne: any;
  element: any;
  id: any;
  lengthItem: any = 0;
  selectedid: any;
  dataForm: FormGroup;
  dataC: any;
  createdAt: any;
  lane_crossing: any;
  created_by: any;
  speeding: any;
  turn: any;
  turn_and_accelerate: any;
  turn_and_brake: any;
  accelerationVehicule: any;
  braking: any;
  spinnerActive: boolean = true;
  listAlarms: any;
  offsetPagination: any = 0;

  onContextMenu(event: MouseEvent, item: any) {
    event.preventDefault();
    this.contextMenuPosition.x = event.clientX + "px";
    this.contextMenuPosition.y = event.clientY + "px";
    this.contextMenu.menuData = { item: item };
    this.contextMenu.menu.focusFirstItem("mouse");
    this.contextMenu.openMenu();
  }

  onContextMenuAction1(item: any) {
    alert(`Click on Supprimer for ${item.name}`);
  }

  onContextMenuAction2(item: any) {
    alert(`Click on Modifier for ${item.name}`);
  }

  onContextMenuAction3(item: any) {
    alert(`Click on Activer/Désactiver for ${item.name}`);
  }

  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    const numSelected = this.selection.selected?.length;
    const numRows = this.dataSourceev.data?.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected()
      ? this.selection.clear()
      : this.dataSourceev.data.forEach((row) => {
          this.selection.select(row);
        });
    console.log("aaaaaaaa " + this.selected);
  }

  /** The label for the checkbox on the passed row */
  checkboxLabel(row?: any): string {
    if (!row) {
      return `${this.isAllSelected() ? "select" : "deselect"} all`;
    }
    this.ItemSelected = this.selection.selected;
    return `${this.selection.isSelected(row) ? "deselect" : "select"} row ${
      row.id + 1
    }`;
  }

  GetSelectedRow(row) {
    if (this.selectedRowIndex === row.id) {
      this.selectedRowIndex = -1;
      this.selected = false;
    } else {
      this.selectedRow = row;
      this.selectedRowIndex = row.id;
      this.selected = true;
      console.log("hello " + this.selectedRowIndex);
    }
  }

  public updateManualPage(index): void {
    console.log(index);
    this.pageNum = index;
    this.manualPage = index;
    this.paginator.pageIndex = index;

    this.paginator.page.next({
      pageIndex: this.paginator.pageIndex,
      pageSize: this.paginator.pageSize,
      length: this.paginator.length,
    });
  }
  //filtre global

  applyFilter(event: Event) {
    this.dataSourceev = new MatTableDataSource(this.tableDataSource);

    const filterValue = (event.target as HTMLInputElement).value;
    console.log(this.dataSourceev);
    this.dataSourceev.filter = filterValue.trim().toLowerCase();
    this.dataSourceev.paginator = this.paginator;
  }

  constructor(
    private formBuilder: FormBuilder,
    private _snackBar: MatSnackBar,
    public dialog: MatDialog,
    private fb: FormBuilder,
    private http: HttpClient,
    public traslateService: TraslateService,
    private spinnerAlarmEvent: NgxSpinnerService
  ) {}
  supprimerAlarme(operation, id: any) {
    console.log("hereeeeeee delete alarm");
    if (operation == "oneItem") {
      this.selection.clear();
      this.ItemSelected = [];
      this.ItemSelected.push({
        id: id,
      });
      console.log("list", this.ItemSelected);
    }
    var array: any = [];
    this.ItemSelected.forEach((el) => {
      array.push(el.id);
    });
    if (array.length === 1) {
      Swal.fire({
        title: "Voulez-vous supprimer l'alarme selectionnée ?",
        showCancelButton: true,
        confirmButtonColor: "#262756",
        cancelButtonColor: "#e05a61",
        allowOutsideClick: false,
        cancelButtonText: "Annuler",
        confirmButtonText: "Oui",
      }).then((result) => {
        if (result.isConfirmed) {
          this.spinnerActive = true;
          this.http
            .delete(environment.apiUrl + "/alarms/" + JSON.stringify(array))
            .subscribe(
              (response: any) => {
                this.ItemSelected = [];
                this.selection.clear();
                this.lengthItem = 0;
                this.listalarm(15, 1);
                Swal.fire(response["message"]);
                this.spinnerActive = false;
              },
              (error) => {
                Swal.fire({
                  text: "Un problème est survenu! " + error,
                });
                this.spinnerActive = false;
              }
            );
        } else {
          this.ItemSelected = [];
          this.selection.clear();
        }
      });
    } else if (array.length >= 1) {
      Swal.fire({
        title: "Voulez-vous supprimer les alarmes sélectionnées ?",
        showCancelButton: true,
        confirmButtonColor: "#262756",
        cancelButtonColor: "#e05a61",
        allowOutsideClick: false,
        cancelButtonText: "Annuler",
        confirmButtonText: "Confirmer!",
      }).then((result) => {
        if (result.isConfirmed) {
          this.spinnerActive = true;
          this.http
            .delete(environment.apiUrl + "/alarms/" + JSON.stringify(array))
            .subscribe(
              (response) => {
                this.ItemSelected = [];
                this.selection.clear();
                this.lengthItem = 0;
                this.listalarm(15, 1);
                Swal.fire(response["message"]);
                this.spinnerActive = false;
              },
              (error) => {
                Swal.fire({
                  text: "Un problème est survenu! " + error,
                });
                this.spinnerActive = false;
              }
            );
        }
      });
    }
  }

  setPageSizeOptions(setPageSizeOptionsInput: string) {
    if (setPageSizeOptionsInput) {
      this.pageSizeOptions1 = setPageSizeOptionsInput
        .split(",")
        .map((str) => +str);
    }
  }

  ngOnInit() {
    this.firstFormGroup = this.formBuilder.group({
      firstCtrl: ["", Validators.required],
    });
    this.secondFormGroup = this.formBuilder.group({
      secondCtrl: ["", Validators.required],
    });

    this.pageSize = 10;
    this.traslateService.UserAlarmEventdataQuote.subscribe((data) => {
      this.url = data;
    });

    const headerDict = {
      "Content-Type": "application/json",
      Accept: "application/json",
      "Access-Control-Allow-Headers": "Content-Type",
    };

    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };
    console.log(JSON.parse(localStorage.getItem("currentUser")).company_id);
    this.spinnerActive = true;
    this.http
      .get(
        environment.apiUrl +
          "/companies/" +
          JSON.parse(localStorage.getItem("currentUser")).company_id +
          "/alarms/type/1" +
          "?page=1",
        requestOptions
      )
      .subscribe((response: any) => {
        // @ts-ignore
        var listAlarms: any = response.data;

        this.lengthTotal = response.total;

        this.repos = listAlarms;
        this.repos.length = response.total;
        console.log(this.repos);

        this.dataSourceev = new MatTableDataSource(this.repos);
        this.dataSourceev.paginator = this.paginator;
        this.tableDataSource = this.repos;
        this.dataSourceev.sort = this.sort;

        this.spinnerActive = false;
      });

    this.dataForm = new FormGroup({
      key: new FormArray(
        this.ItemSelected?.map(
          (data) => new FormControl(data?.key, [Validators.required])
        )
      ),
      // Add other form groups or form controls here
    });
  }

  getItem() {
    this.lengthItem = this.selection.selected.length;
  }

  listalarm(currentSize, offset) {
    const headerDict = {
      "Content-Type": "application/json",
      Accept: "application/json",
      "Access-Control-Allow-Headers": "Content-Type",
    };

    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };
    this.spinnerActive = true;
    this.http
      .get(
        environment.apiUrl +
          "/companies/" +
          JSON.parse(localStorage.getItem("currentUser")).company_id +
          "/alarms/type/1" +
          "?page=" +
          offset,
        requestOptions
      )
      .subscribe(
        (response) => {
          // @ts-ignore
          this.listAlarms = response.data;
          // @ts-ignore
          this.lengthTotal = response.total;
          this.repos = this.listAlarms;
          // @ts-ignore
          this.repos?.length = response?.total;
          this.dataSourceev = new MatTableDataSource(this.repos);
          this.dataSourceev.paginator = this.paginator;
          this.dataSourceev.sort = this.sort;
          //this.spinnerAlarmHistory.show()
          //this.alarmHistory = false
        },
        (error) => {
          Swal.fire({
            text: "Un problème est survenu! " + error,
          });

          this.spinnerActive = false;
        }
      );
  }

  pageChanged(event) {
    let pageIndex = event.pageIndex;
    let pageSize = event.pageSize;

    let previousIndex = event.previousPageIndex;

    let previousSize = pageSize * pageIndex;
    this.getNextData(previousSize, pageIndex.toString(), pageSize.toString());
  }

  getNextData(currentSize, offset, limit) {
    const headerDict = {
      "Content-Type": "application/json",
      Accept: "application/json",
      "Access-Control-Allow-Headers": "Content-Type",
    };
    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };
    //this.alarmHistory = true;
    this.offsetPagination = parseInt(offset) + 1;
    this.http
      .get(
        environment.apiUrl +
          "/companies/" +
          JSON.parse(localStorage.getItem("currentUser")).company_id +
          "/alarms/type/1" +
          "?page=" +
          this.offsetPagination,
        requestOptions
      )
      .subscribe((response) => {
        // @ts-ignore
        console.log("page", response);
        // @ts-ignore
        this.repos.length = currentSize;
        // @ts-ignore
        this.repos.push(...response.data);
        // @ts-ignore
        this.repos.length = response.total;
        //this.alarmHistory = false;
        this.dataSourceev = new MatTableDataSource<any>(this.repos);
        this.dataSourceev._updateChangeSubscription();
        this.dataSourceev.paginator = this.paginator;
      });
  }

  async afficher_info(row) {
    if (this.ItemSelected.length == 0) {
      this.ItemSelected.push(row);
    }
    if (this.ItemSelected.length === 1) {
      for (let e of this.ItemSelected) {
        this.Nom = e.created_by;
        this.createdAt = e.created_at;
        this.lane_crossing = e.lane_crossing + "%";
        this.created_by = e.created_by + "%";
        this.speeding = e.speeding + "%";
        this.turn = e.turn + "%";
        this.turn_and_accelerate = e.turn_and_accelerate + "%";
        this.turn_and_brake = e.turn_and_brake + "%";
        this.accelerationVehicule = e.acceleration + "%";
        this.braking = e.braking + "%";
      }
      const { value: formValues } = await Swal.fire({
        border: " 1px solid #262853",
        width: 900,
        opacity: 1,
        background: "rgba(238,238,238,0)",
        showConfirmButton: false,
        html:
          '<div style="background: rgba(255, 255, 255, 0.8);border-radius: 16px;box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);backdrop-filter: blur(13.7px);' +
          '-webkit-backdrop-filter: blur(8px);border: 1px solid rgba(255, 255, 255, 0.22);  border: 1px solid #262853;border-radius: 25px;">' +
          "<div>" +
          '<h1 class="pb-4" style="color :#262756;margin-right: 55%;margin-top: 5%;" > <strong> Détails d\'alarme </strong> <h1>' +
          "</div>" +
          '<table class="swal" style="color :#262756;margin-left: 15%; text-align: left; margin-bottom: 10%;">' +
          ' <tr style="height: 24px !important;" ><td><h2 style="font-size: 15px;padding:0px; margin:0px;">Créé par : </h2></td><td><h3 style="font-size: 15px; padding:0px; margin:0px;"> ' +
          this.Nom +
          "</h3></td></tr>" +
          ' <tr style="height: 14px !important;"><td><h2 style="font-size: 15px; padding:0px; margin:0px;">Vitesse (<) : </h2></td><td><h3 style="font-size: 15px; padding:0px; margin:0px;"> ' +
          (this.speeding != null ? this.speeding : "---") +
          "</h3></td></tr>" +
          ' <tr style="height: 14px !important;"><td><h2 style="font-size: 15px; padding:0px; margin:0px;">Virage (<) : </h2></td><td><h3 style="font-size: 15px; padding:0px; margin:0px;"> ' +
          (this.turn != null ? this.turn : "---") +
          "</h3></td></tr>" +
          ' <tr style="height: 4px !important;"><td><h2 style="font-size: 15px; padding:0px; margin:0px;"> Accéleration (<)  : </h2></td><td><h3 style="font-size: 15px; padding:0px; margin:0px;"> ' +
          (this.accelerationVehicule != null
            ? this.accelerationVehicule
            : "---") +
          "</h3></td></tr>" +
          ' <tr style="height: 4px !important;"><td><h2 style="font-size: 15px; padding:0px; margin:0px;"> Freinage (<)  : </h2></td><td><h3 style="font-size: 15px; padding:0px; margin:0px;"> ' +
          (this.braking != null ? this.braking : "---") +
          "</h3></td></tr>" +
          ' <tr style="height: 14px; padding:0px; margin:0px;"><td><h2 style="font-size: 15px;padding:0px; margin:0px;">Franchissement ligne (<) : </h2></td><td><h3 style="font-size: 15px;padding:0px; margin:0px;"> ' +
          (this.lane_crossing != null ? this.lane_crossing : "---") +
          "</h3></td></tr>" +
          ' <tr style="height: 14px; padding:0px; margin:0px;"><td><h2 style="font-size: 15px;padding:0px; margin:0px;"> Virage & Accéleration (<) : </h2></td><td><h3 style="font-size: 15px;padding:0px; margin:0px;"> ' +
          (this.turn_and_accelerate != null
            ? this.turn_and_accelerate
            : "---") +
          "</h3></td></tr>" +
          ' <tr style="height: 14px; padding:0px; margin:0px;"><td><h2 style="font-size: 15px;padding:0px; margin:0px;"> Virage & Freinage (<) : </h2></td><td><h3 style="font-size: 15px;padding:0px; margin:0px;"> ' +
          (this.turn_and_brake != null ? this.turn_and_brake : "---") +
          "</h3></td></tr>" +
          ' <tr style="height: 14px; padding:0px; margin:0px;"><td><h2 style="font-size: 15px;padding:0px; margin:0px;">Date de création : </h2></td><td><h3 style="font-size: 15px;padding:0px; margin:0px;"> ' +
          new Date(this.createdAt).toLocaleString() +
          "</h3></td></tr>" +
          "</table>" +
          "</div>",
      }).then((result) => {
        if (result.isConfirmed) {
        } else {
          this.ItemSelected = [];
          this.selection.clear();
        }
      });
    } else if (this.ItemSelected.length >= 1) {
      Swal.fire({
        title: "Veuillez sélectionnner un seul enregistrement !",
      });
    } else {
      Swal.fire({
        title: "Veuillez sélectionnner un enregistrement !",
      });
    }
  }

  modifierAlarme(operation, id: any, row) {
    // if (this.ItemSelected.length == 1) {
    if (operation == "oneItem") {
      this.selection.clear();
      this.ItemSelected = [];
      this.ItemSelected.push({
        id: id,
      });
    }
    this.ItemSelected = this.selection.selected;
    let dialogRef = this.dialog.open(DialogEditAlarmEv, {
      disableClose: true,
      data: {
        animal: "panda",
      },
      width: "70%",
      height: "90%",
      panelClass: "my-custom-dialog-class",
    });
    dialogRef.afterClosed().subscribe((result) => {
      console.log("close dialog ");
      this.selection.clear();
    });
    // console.log("ItemSelected ItemSelected");
    // console.log(this.ItemSelected);

    this.traslateService.UserAlarmEventQuote.next([row]);
    for (let e of this.ItemSelected) {
      this.CodePostal = e.CodePostal;
      this.Groupe = e.Groupe;
      this.Nom = e.name;
      this.dataC = e.contacts;
    }
    // }
    // else if (this.ItemSelected.length >= 1) {
    //   Swal.fire({
    //     title: 'Veuillez sélectionner un seul enregistrement à modifier',
    //   })
    // }
    // else {
    //   Swal.fire({
    //     title: 'Veuillez sélectionner un enregistrement',
    //   })
    // }
  }

  exportExcel(e, e2) {
    Swal.fire({
      title: "Souhaitez-vous exporter table ?",
      showCancelButton: true,
      confirmButtonColor: "#262756",
      cancelButtonColor: "#e05a61",
      confirmButtonText: "Exporter Fichier !",
      cancelButtonText: "Annuler",
    }).then((result) => {
      if (result.value) {
        Swal.fire("Export!", "Le fichier est exporté.");
        console.log(e);
        e.exportTable(e2);
      } else if (result.dismiss === Swal.DismissReason.cPDFfileancel) {
        Swal.fire("Annuler", " Fichier non exporté !!");
      }
    });
  }

  exportTable() {
    Swal.fire({
      title: "Souhaitez-vous exporter la table ?",
      showCancelButton: true,
      confirmButtonColor: "#262756",
      cancelButtonColor: "#e05a61",
      confirmButtonText: "Démarrer l'exportation",
      cancelButtonText: "Annuler",
    }).then((result) => {
      if (result.value) {
        PdfUtil.exportToPdf("ExampleTable", "tbl");
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire("Annulé", "Fichier non exporté !!");
      }
    });
  }
}

@Component({
  selector: "dialog-elements-example-dialog",
  styleUrls: ["./user-alarm.component.scss"],
  templateUrl: "AddAlarm.html",
  providers: [
    {
      provide: STEPPER_GLOBAL_OPTIONS,
      useValue: { displayDefaultIndicatorType: true },
    },
  ],
})
export class DialogAddAlarmEv implements OnInit {
  public maxValue: number = 100;
  public minValue: number = 0;
  firstFormGroup: FormGroup;
  secondFormGroup: FormGroup;
  accelerationinput: boolean = false;
  bosseinput: boolean = false;
  hors_pisteinput: boolean = false;
  franch_de_ligne_input: boolean = false;
  excesvitesseinput: boolean = false;
  freinage_input: boolean = false;
  vir_accelerationinput: boolean = false;
  vir_frein_input: boolean = false;
  virageinput: boolean = false;
  alarmActive: boolean;
  alarmtranche: boolean;
  name: any;
  entry: any;
  submitStatus: boolean;
  url: any;
  acceleration: number;
  freinage: any;
  virage: any;
  virage_freinage: any;
  exces_vitesse: any;
  virage_acceleration: any;
  franchissement_ligne: any;
  hiddenContact: string = "false";
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild("secondPaginator", { static: true }) secondPaginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  tableDataSourceContact: any = [];
  selection = new SelectionModel<any>(true, []);
  selectedRow;
  selected: boolean;
  ItemSelected: any[];
  arr: any = [];
  repos: any;
  entryC: any;
  lengthTotal: any;
  displayedColumns: string[] = [
    "id",
    "first_name",
    "last_name",
    "email",
    "delete",
  ];
  dataSource = new MatTableDataSource();
  matcher = new MyErrorStateMatcher();
  contacts = new FormControl();
  contactList: any = "";
  new_contact: boolean;
  urlC: any;
  id: any;
  first_name: any;
  last_name: any;
  gsm: any;
  email: any;
  lengthItem: any = null;
  selectedRowIndex: number = -1;
  dataSourcet: any;
  myControl = new FormControl();
  selectedRowIndex2 = -1;
  displayedColumnst: string[] = ["position"];
  itemSelect2: any;
  contact_notif: any = [];
  dataSourceC = new MatTableDataSource();
  testrr: any = [];
  contactHafsae: any;
  contact_notif2: any = [];
  itemm: any = localStorage.getItem("contact");
  contact_notif3: any;
  level: any;
  entity_id: any;

  constructor(
    public dialogRef: MatDialogRef<DialogAddAlarmEv>,
    private _formBuilder: FormBuilder,
    public traslateService: TraslateService,
    private http: HttpClient,
    private formBuilder: FormBuilder,
    private _snackBar: MatSnackBar,
    private spinnerAlarmEvent: NgxSpinnerService
  ) {
    this.getItem();
    this.getContactSelect();
    const headerDict = {
      "Content-Type": "application/json",
      Accept: "application/json",
      "Access-Control-Allow-Headers": "Content-Type",
    };

    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };
    this.http
      .get(
        environment.apiUrl +
          "/companies/" +
          JSON.parse(localStorage.getItem("currentUser")).company_id +
          "/contacts/all",
        requestOptions
      )
      .subscribe(
        (response) => {
          var listContacts: any = response;
          this.lengthTotal = listContacts.length;
          this.repos = listContacts;
          this.dataSource = new MatTableDataSource(this.repos);
          this.dataSource.paginator = this.paginator;
          this.tableDataSourceContact = this.repos;
          this.dataSource.sort = this.sort;
        },
        (error) => {
          Swal.fire({
            text: "Un problème est survenu! " + error,
          });
        }
      );
  }

  setEntityIDVEh(event) {
    console.log("entity_id", event.id);
    this.registerForm.setControl("entity_id", new FormControl(event.id));
  }

  getItemDetails2(e) {
    this.itemSelect2 = e.id;
    this.first_name = e.first_name;
    this.last_name = e.last_name;
    this.email = e.email;
    console.log(e);
    console.log(this.registerForm.value);
    if (this.registerForm.invalid) {
      return;
    }
    if (!this.contact_notif.some((item) => item.id == e.id)) {
      this.contact_notif.push(e);
      this.contact_notif2.push(e.id);
      this.selectedRowIndex2 = e.id;
      this.hiddenContact = "jkhjk";
      localStorage.setItem("contact1", this.contact_notif2);
      var ids = localStorage.getItem("contact1");
      var ids2 = ids.split(",");
      this.contact_notif3 = ids2;
      console.log(ids2);
      console.log(this.formBuilder.array(ids2));
      console.log("000000000", this.level, this.entity_id);
      // tslint:disable-next-line:member-ordering
      this.registerForm.setControl(
        "contacts",
        new FormControl(JSON.stringify(ids2))
      );

      console.log(this.registerForm, "====");
    } else {
      Swal.fire({
        position: "center",
        title: "Contact déjà selectionné !",
        text: "Veillez selectionner un autre contact à notifier !",
        showConfirmButton: false,
        timer: 4000,
      });
    }
  }

  getContact_notif() {
    this.dataSourceC = new MatTableDataSource(this.contact_notif);
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  getItem() {
    var ids = localStorage.getItem("contact1");
    localStorage.setItem("contact", this.contact_notif2);
  }

  listalarm() {
    const headerDict = {
      "Content-Type": "application/json",
      Accept: "application/json",
      "Access-Control-Allow-Headers": "Content-Type",
    };
    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };
    console.log(JSON.parse(localStorage.getItem("currentUser")).company_id);
    this.http
      .get(
        environment.apiUrl +
          "/companies/" +
          JSON.parse(localStorage.getItem("currentUser")).company_id +
          "/alarms/type/1",
        requestOptions
      )
      .subscribe(
        (response) => {
          var listAlarms: any = response;
          this.lengthTotal = listAlarms.length;
          this.repos = listAlarms;
          this.dataSource = new MatTableDataSource(this.repos);
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
        },
        (error) => {
          Swal.fire({
            text: "Un problème est survenu! " + error,
          });
        }
      );
  }

  hiddencontenu() {
    this.hiddenContact = "true";
  }

  applyFilter1(event: Event) {
    const filterValue2 = (event.target as HTMLInputElement).value;
    this.dataSourcet.filter = filterValue2.trim().toLowerCase();
    if (this.dataSourcet.paginator) {
      this.dataSourcet.paginator.firstPage();
    }
    this.hiddenContact = "true";
  }

  public hiddencontenu2() {
    this.hiddenContact = "jkhjk";
  }

  async refrech() {
    const headerDict = {
      "Content-Type": "application/json",
      Accept: "application/json",
      "Access-Control-Allow-Headers": "Content-Type",
    };
    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };

    this.http
      .get(
        environment.apiUrl +
          "/companies/" +
          JSON.parse(localStorage.getItem("currentUser")).company_id +
          "/contacts/all",
        requestOptions
      )
      .subscribe(
        (response) => {
          console.log(response);
          this.contactList = response;
          console.log("contactList" + this.contactList);
          this.dataSourcet = new MatTableDataSource(this.contactList);
          this.dataSourcet.paginator = this.secondPaginator;
          this._snackBar.open(
            "la liste des contacts est actualisée ",
            "Fermer",
            {
              duration: 2500,
            }
          );
        },
        (error) => {
          Swal.fire({
            text: "Un problème est survenu! " + error,
          });
        }
      );
  }

  getContactSelect() {
    const headerDict = {
      "Content-Type": "application/json",
      Accept: "application/json",
      "Access-Control-Allow-Headers": "Content-Type",
    };
    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };
    this.http
      .get(
        environment.apiUrl +
          "/companies/" +
          JSON.parse(localStorage.getItem("currentUser")).company_id +
          "/contacts/all",
        requestOptions
      )
      .subscribe(
        (response) => {
          //console.log(response)
          this.contactList = response;
          //console.log('contactList          '+this.contactList);
          this.dataSourcet = new MatTableDataSource(this.contactList);
          this.dataSourcet.paginator = this.secondPaginator;
        },
        (error) => {
          Swal.fire({
            text: "Un problème est survenu! " + error,
          });
        }
      );
  }

  registerForm: FormGroup = this.formBuilder.group({
    // tslint:disable-next-line:quotemar
    acceleration: ["", Validators.compose([Validators.max(100)])],
    braking: [],
    company: [],
    company_id: [],
    created_at: [],
    created_by: [],
    id: [],
    lane_crossing: [],
    period: [],
    speeding: [],
    turn: [],
    turn_and_accelerate: [],
    turn_and_brake: [],
    type: [],
    updated_at: [],
    contacts: [JSON.stringify([])],
    level: 1,
    entity_id: [],
  });

  async ngOnInit(): Promise<void> {
    this.registerForm = this.formBuilder.group({
      // tslint:disable-next-line:quotemar
      acceleration: ["", Validators.compose([Validators.max(100)])],
      braking: ["", Validators.compose([Validators.max(100)])],
      company: [],
      company_id: [],
      created_at: [],
      created_by: [],
      id: [],
      lane_crossing: ["", Validators.compose([Validators.max(100)])],
      period: [],
      speeding: ["", Validators.compose([Validators.max(100)])],
      turn: ["", Validators.compose([Validators.max(100)])],
      turn_and_accelerate: ["", Validators.compose([Validators.max(100)])],
      turn_and_brake: ["", Validators.compose([Validators.max(100)])],
      type: [],
      updated_at: [],
      contacts: [],
      level: 1,
      entity_id: [],
    });
    this.itemm = localStorage.getItem("contact");
    this.name = JSON.parse(localStorage.getItem("currentUser")).company;
    this.traslateService.UserAlarmEventdataQuote.subscribe((data) => {
      this.url = data;
    });
    this.firstFormGroup = this._formBuilder.group({
      firstCtrl: ["", Validators.required],
    });
    this.secondFormGroup = this._formBuilder.group({
      secondCtrl: ["", Validators.required],
    });
    this.getContactSelect();
  }

  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    const numSelected = this.selection.selected?.length;
    const numRows = this.dataSource.data?.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected()
      ? this.selection.clear()
      : this.dataSource.data.forEach((row) => {
          this.selection.select(row);
        });
  }

  /** The label for the checkbox on the passed row */
  checkboxLabel(row?: any): string {
    if (!row) {
      return `${this.isAllSelected() ? "select" : "deselect"} all`;
    }
    this.ItemSelected = this.selection.selected;
    return `${this.selection.isSelected(row) ? "deselect" : "select"} row ${
      row.id + 1
    }`;
  }

  getContactNotif() {
    this.lengthItem = this.selection.selected.length;
  }

  GetSelectedRow(row) {
    if (this.selectedRowIndex === row.id) {
      this.selectedRowIndex = -1;
      this.selected = false;
    } else {
      this.selectedRow = row;
      this.selectedRowIndex = row.id;
      this.selected = true;
      console.log("hello " + this.selectedRowIndex);
    }
  }

  getContact() {
    const headerDict = {
      "Content-Type": "application/json",
      Accept: "application/json",
      "Access-Control-Allow-Headers": "Content-Type",
    };

    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };
    console.log(JSON.parse(localStorage.getItem("currentUser")).company_id);
    this.http
      .get(
        environment.apiUrl +
          "/companies/" +
          JSON.parse(localStorage.getItem("currentUser")).company_id +
          "/contacts",
        requestOptions
      )
      .subscribe((response) => {
        var listContacts: any = response;
        this.lengthTotal = listContacts.length;
        this.repos = listContacts;
        this.contactList = listContacts;
        this.dataSource = new MatTableDataSource(this.repos);
        this.dataSource.paginator = this.paginator;
        this.tableDataSourceContact = this.repos;
        this.dataSource.sort = this.sort;
      });
  }
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  registerFormContact: FormGroup = this.formBuilder.group({
    // tslint:disable-next-line:quotemar
    last_name: [
      "",
      {
        validators: [
          Validators.required,
          Validators.pattern(/^[a-zA-Z][a-zA-Z\s]+$/),
        ],
        updateOn: "change",
      },
    ],
    email: [
      "",
      {
        validators: [Validators.required, Validators.email],
        updateOn: "change",
      },
    ],

    gsm_number: [],
    first_name: [
      "",
      {
        validators: [
          Validators.required,
          Validators.pattern(/^[a-zA-Z][a-zA-Z\s]+$/),
        ],
        updateOn: "change",
      },
    ],
    company_id: [],
    created_at: [],
    created_by: [],
    id: [],
    updated_at: [],
  });

  add_contact() {
    this.new_contact = !this.new_contact;
  }

  submitcontact() {
    console.log("LKLK" + this.registerFormContact);
    if (this.registerFormContact.invalid) {
      return;
    }
    Object.values(this.registerFormContact).forEach((val) => {
      console.log(val);
    });
    this.submitStatus = true;
    this.http
      .post(
        environment.apiUrl +
          "/companies/" +
          JSON.parse(localStorage.getItem("currentUser")).company_id +
          "/contacts/all",
        this.registerFormContact.value
      )
      .subscribe(
        (data) => {
          var statuscontact: any = data;
          console.log(data);
          if (statuscontact.status == 200) {
            Swal.fire({
              position: "center",
              title: "Contact ajouté avec succées !",
              showConfirmButton: false,
              timer: 4000,
            });
            this.getContactSelect();
          } else {
            console.log("500 status");
            Swal.fire({
              text: statuscontact.response + "!",
            });
          }
        },
        (error) => {
          Swal.fire({
            text: "Un problème est survenu! " + error,
          });
        }
      );
    //location.reload()
  }

  Delete_contact(e) {
    this.getContact_notif();
    localStorage.removeItem("contact1");
    this.contact_notif.splice(e, 1);
    this.contact_notif2.splice(e, 1);
    localStorage.setItem("contact1", this.contact_notif2);
    var ids = localStorage.getItem("contact1");
    // tslint:disable-next-line:member-ordering
    var ids2 = ids.split(",");
    this.registerForm.setControl(
      "contacts",
      new FormControl(JSON.stringify(ids2))
    );
  }

  select_contact() {
    this.new_contact = false;
  }
  testarr: any = [1, 2];

  onNoClick(): void {
    this.dialogRef.close();
    localStorage.removeItem("contact1");
  }

  submitForm() {
    Object.values(this.registerForm).forEach((val) => {
      console.log(val);
    });
    this.submitStatus = true;
    this.listalarm();
    if (this.registerForm.invalid) {
      return;
    }
    console.log("**************1", this.registerForm.value);
    if (this.registerForm.get("level")?.value === 1)
      this.registerForm.setControl(
        "entity_id",
        new FormControl(
          JSON.parse(localStorage.getItem("currentUser")).company_id
        )
      );
    console.log("**************", this.registerForm.value);
    this.http
      .post(
        environment.apiUrl +
          "/companies/" +
          JSON.parse(localStorage.getItem("currentUser")).company_id +
          "/alarms/type/1",
        this.registerForm.value
      )
      .subscribe(
        (data) => {
          var statuscontact: any = data;
          console.log(data);
          if (statuscontact.status == 200) {
            Swal.fire({
              position: "center",
              title: "Alarme ajoutée avec succées !",
              allowOutsideClick: false,
              showConfirmButton: false,
              timer: 1000,
            });
            location.reload();
            localStorage.removeItem("contact1");
          } else {
            console.log("500 status");
            Swal.fire({
              text: statuscontact.response + "!",
            });
          }
        },
        (error) => {
          Swal.fire({
            text: "Un problème est survenu! " + error,
          });
        }
      );
  }

  enableacceleration() {
    this.accelerationinput = !this.accelerationinput;
  }

  enablevirage() {
    this.virageinput = !this.virageinput;
  }

  enablevir_frein() {
    this.vir_frein_input = !this.vir_frein_input;
  }

  enableexcesvitesse() {
    this.excesvitesseinput = !this.excesvitesseinput;
  }

  enable_vir_acceleration() {
    this.vir_accelerationinput = !this.vir_accelerationinput;
  }

  enable_franch_de_ligne() {
    this.franch_de_ligne_input = !this.franch_de_ligne_input;
  }

  enablehors_piste() {
    this.hors_pisteinput = !this.hors_pisteinput;
  }

  enablebosse() {
    this.bosseinput = !this.bosseinput;
  }

  alarm_active_tranches() {
    this.alarmtranche = true;
  }

  alarm_tjrs_active() {
    this.alarmtranche = false;
  }

  enable_F() {
    this.freinage_input = !this.freinage_input;
    console.log("changed");
  }
}

@Component({
  selector: "dialog-elements-example-dialog",
  styleUrls: ["./user-alarm.component.scss"],
  templateUrl: "EditAlarm.html",
  providers: [
    {
      provide: STEPPER_GLOBAL_OPTIONS,
      useValue: { displayDefaultIndicatorType: true },
    },
  ],
})
export class DialogEditAlarmEv implements OnInit {
  firstFormGroup: FormGroup;
  secondFormGroup: FormGroup;
  accelerationinput: boolean = false;
  bosseinput: boolean = false;
  hors_pisteinput: boolean = false;
  franch_de_ligne_input: boolean = false;
  excesvitesseinput: boolean = false;
  vir_accelerationinput: boolean = false;
  freinage_input: boolean = false;
  vir_frein_input: boolean = false;
  virageinput: boolean = false;
  alarmActive: boolean;
  alarmtranche: boolean;
  compagnie: any;
  url: any;
  name: any;
  acceleration: any;
  freinage: any;
  virage: any;
  virage_freinage: any;
  exces_vitesse: any;
  virage_acceleration: any;
  franchissement_ligne: any;
  submitStatus: boolean;
  id: any;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild("secondPaginator", { static: true }) secondPaginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  tableDataSourceContact: any = [];
  selection = new SelectionModel<any>(true, []);
  selectedRow;
  selected: boolean;
  ItemSelected: any[];
  arr: any = [];
  repos: any;
  entryC: any;
  lengthTotal: any;
  hiddenContact: string = "false";
  displayedColumns: string[] = [
    "id",
    "first_name",
    "last_name",
    "email",
    "delete",
  ];
  dataSource = new MatTableDataSource();
  matcher = new MyErrorStateMatcher();
  contacts = new FormControl();
  contactList: any = "";
  new_contact: boolean;
  urlC: any;
  idC: any;
  first_name: any;
  last_name: any;
  gsm: any;
  email: any;
  lengthItem: any = null;
  selectedRowIndex: number = -1;
  dataSourcet: any;
  myControl = new FormControl();
  selectedRowIndex2 = -1;
  displayedColumnst: string[] = ["position"];
  itemSelect2: any;
  contact_notif: any = [];
  dataSourceC = new MatTableDataSource();
  contactList1: any = [];
  contact_notif1: any = [];
  contact_notif2: any = [];
  listAlarms: any;
  offsetPagination: any = 0;
  level: any;
  entity_id: any;
  company_id: any;
  selectedUnit: any = { name: "" };
  getItemDetails2(e) {
    this.itemSelect2 = e.id;
    this.first_name = e.first_name;
    this.last_name = e.last_name;
    this.email = e.email;
    if (!this.contact_notif.some((item) => item.id == e.id)) {
      this.contact_notif.push(e);
      this.contact_notif2.push(e.id);
      this.hiddenContact = "jkhjk";
      localStorage.setItem("contact1", this.contact_notif2);
      var ids = localStorage.getItem("contact1");
      var ids2 = ids.split(",");
      console.log(ids2);

      this.registerForm2.setControl(
        "contacts",
        new FormControl(JSON.stringify(ids2))
      );
      console.log(this.registerForm2);
    } else {
      Swal.fire({
        position: "center",
        title: "Contact déjà selectionné !",
        text: "Veillez selectionner un autre contact à notifier !",
        showConfirmButton: false,
        timer: 4000,
      });
    }

    // this.contact_notif.push(e);
    console.log(this.contact_notif);
  }

  setEntityIDVEh(event) {
    console.log("entity_id", event.id);
    this.registerForm2.setControl("entity_id", new FormControl(event.id));
  }
  listalarm(currentSize, offset) {
    const headerDict = {
      "Content-Type": "application/json",
      Accept: "application/json",
      "Access-Control-Allow-Headers": "Content-Type",
    };

    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };
    console.log(JSON.parse(localStorage.getItem("currentUser")).company_id);
    this.http
      .get(
        environment.apiUrl +
          "/companies/" +
          JSON.parse(localStorage.getItem("currentUser")).company_id +
          "/alarms/type/1" +
          "?page=" +
          offset,
        requestOptions
      )
      .subscribe(
        (response: any) => {
          this.listAlarms = response.data;
          this.lengthTotal = this.listAlarms.length;
          this.repos = this.listAlarms;
          this.dataSource = new MatTableDataSource(this.repos);
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
          this.dataSource = new MatTableDataSource(this.repos);
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
        },
        (error) => {
          Swal.fire({
            text: "Un problème est survenu! " + error,
          });
        }
      );
  }

  pageChanged(event) {
    let pageIndex = event.pageIndex;
    let pageSize = event.pageSize;
    let previousIndex = event.previousPageIndex;
    let previousSize = pageSize * pageIndex;
    this.getNextData(previousSize, pageIndex.toString(), pageSize.toString());
  }

  getNextData(currentSize, offset, limit) {
    const headerDict = {
      "Content-Type": "application/json",
      Accept: "application/json",
      "Access-Control-Allow-Headers": "Content-Type",
    };

    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };
    this.offsetPagination = parseInt(offset) + 1;
    this.http.get(this.url, requestOptions).subscribe((response) => {
      // this.spinnerevents.hide();
      this.listAlarms.length = currentSize;
      // @ts-ignore
      console.log("page", response);
      // @ts-ignore
      this.list.push(...response.data);
      // @ts-ignore
      this.list.length = response.total;
      this.dataSource = new MatTableDataSource<any>(this.listAlarms);
      this.dataSource._updateChangeSubscription();
      this.dataSource.paginator = this.paginator;
    });
  }

  getContact_notif() {
    this.dataSourceC = new MatTableDataSource(this.contact_notif);
  }

  constructor(
    public dialogRef: MatDialogRef<DialogEditAlarmEv>,
    private units: UnitsService,
    public traslateService: TraslateService,
    private _formBuilder: FormBuilder,
    private http: HttpClient,
    private formBuilder: FormBuilder,
    private _snackBar: MatSnackBar,
    private spinnerAlarmEvent: NgxSpinnerService
  ) {
    this.traslateService.UserAlarmEventdataQuote.subscribe((data) => {
      this.url = data;
    });
    this.getContactSelect();
    const headerDict = {
      "Content-Type": "application/json",
      Accept: "application/json",
      "Access-Control-Allow-Headers": "Content-Type",
    };

    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };
    console.log(JSON.parse(localStorage.getItem("currentUser")).company_id);
    this.http
      .get(
        environment.apiUrl +
          "/companies/" +
          JSON.parse(localStorage.getItem("currentUser")).company_id +
          "/contacts/all",
        requestOptions
      )
      .subscribe(
        (response) => {
          var listContacts: any = response;
          this.lengthTotal = listContacts.length;
          this.repos = listContacts;
          console.log(this.repos);
          this.dataSource = new MatTableDataSource(this.repos);
          this.dataSource.paginator = this.paginator;
          this.tableDataSourceContact = this.repos;
          this.dataSource.sort = this.sort;
        },
        (error) => {
          Swal.fire({
            text: "Un problème est survenu! " + error,
          });
        }
      );
  }

  hiddencontenu() {
    this.hiddenContact = "true";
  }

  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    const numSelected = this.selection.selected?.length;
    const numRows = this.dataSource.data?.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected()
      ? this.selection.clear()
      : this.dataSource.data.forEach((row) => {
          this.selection.select(row);
        });
  }

  /** The label for the checkbox on the passed row */
  checkboxLabel(row?: any): string {
    if (!row) {
      return `${this.isAllSelected() ? "select" : "deselect"} all`;
    }
    this.ItemSelected = this.selection.selected;
    return `${this.selection.isSelected(row) ? "deselect" : "select"} row ${
      row.id + 1
    }`;
  }

  getContactNotif() {
    this.lengthItem = this.selection.selected.length;
    console.log(" contact selected   " + this.lengthItem);
  }

  GetSelectedRow(row) {
    if (this.selectedRowIndex === row.id) {
      this.selectedRowIndex = -1;
      this.selected = false;
    } else {
      this.selectedRow = row;
      this.selectedRowIndex = row.id;
      this.selected = true;

      console.log("hello" + this.selectedRowIndex);
    }
  }

  applyFilter1(event: Event) {
    const filterValue2 = (event.target as HTMLInputElement).value;
    this.dataSourcet.filter = filterValue2.trim().toLowerCase();

    if (this.dataSourcet.paginator) {
      this.dataSourcet.paginator.firstPage();
    }

    this.hiddenContact = "true";
  }

  public hiddencontenu2() {
    this.hiddenContact = "jkhjk";
  }

  async refrech() {
    const headerDict = {
      "Content-Type": "application/json",
      Accept: "application/json",
      "Access-Control-Allow-Headers": "Content-Type",
    };
    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };
    this.http
      .get(
        environment.apiUrl +
          "/companies/" +
          JSON.parse(localStorage.getItem("currentUser")).company_id +
          "/contacts/all",
        requestOptions
      )
      .subscribe(
        (response) => {
          this.contactList = response;
          this.dataSourcet = new MatTableDataSource(this.contactList);
          this.dataSourcet.paginator = this.secondPaginator;
          this._snackBar.open(
            "la liste des contacts est actualisée ",
            "Fermer",
            {
              duration: 2500,
            }
          );
        },
        (error) => {
          Swal.fire({
            text: "Un problème est survenu! " + error,
          });
        }
      );
  }

  getContactSelect() {
    const headerDict = {
      "Content-Type": "application/json",
      Accept: "application/json",
      "Access-Control-Allow-Headers": "Content-Type",
    };
    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };
    this.http
      .get(
        environment.apiUrl +
          "/companies/" +
          JSON.parse(localStorage.getItem("currentUser")).company_id +
          "/contacts/all",
        requestOptions
      )
      .subscribe(
        (response) => {
          this.contactList = response;
          this.dataSourcet = new MatTableDataSource(this.contactList);
          this.dataSourcet.paginator = this.secondPaginator;
        },
        (error) => {
          Swal.fire({
            text: "Un problème est survenu! " + error,
          });
        }
      );
  }

  getContactsN(e) {
    const headerDict = {
      "Content-Type": "application/json",
      Accept: "application/json",
      "Access-Control-Allow-Headers": "Content-Type",
    };
    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };
    this.http
      .get(
        environment.apiUrl +
          "/companies/" +
          JSON.parse(localStorage.getItem("currentUser")).company_id +
          "/contacts/all",
        requestOptions
      )
      .subscribe(
        (response: any) => {
          this.contactList1 = response;
          console.log(this.contactList1);
          for (let i of JSON.parse(e.contacts)) {
            for (let element of this.contactList1) {
              if (element.id === i) {
                this.contact_notif.push(element);
                this.contact_notif2.push(element.id);
                localStorage.setItem("contact1", this.contact_notif2);
              }
            }
          }
          this.dataSourceC = new MatTableDataSource(this.contact_notif);
        },
        (error) => {
          Swal.fire({
            text: "Un problème est survenu! " + error,
          });
          this.spinnerAlarmEvent.hide();
        }
      );
  }

  getContact() {
    const headerDict = {
      "Content-Type": "application/json",
      Accept: "application/json",
      "Access-Control-Allow-Headers": "Content-Type",
    };
    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };
    this.http
      .get(
        environment.apiUrl +
          "/companies/" +
          JSON.parse(localStorage.getItem("currentUser")).company_id +
          "/contacts",
        requestOptions
      )
      .subscribe((response) => {
        var listContacts: any = response;
        this.lengthTotal = listContacts.length;
        this.repos = listContacts;
        this.contactList = listContacts;
        this.dataSource = new MatTableDataSource(this.repos);
        this.dataSource.paginator = this.paginator;
        this.tableDataSourceContact = this.repos;
        this.dataSource.sort = this.sort;
      });
  }

  ngOnInit() {
    this.traslateService.UserAlarmEventdataQuote.subscribe((data) => {
      this.url = data;
    });
    for (let entry of this.url) {
      this.id = entry.id;
      this.level = entry.level;
      this.entity_id = entry.entity_id;
      this.name = entry.company;
      this.acceleration = entry.acceleration;
      this.freinage = entry.braking;
      this.virage = entry.turn;
      this.virage_freinage = entry.turn_and_brake;
      this.virage_acceleration = entry.turn_and_accelerate;
      this.exces_vitesse = entry.speeding;
      this.franchissement_ligne = entry.lane_crossing;
      this.contacts = entry.contacts;
      this.company_id = entry.company_id;
      this.getContactsN(entry);
    }
    this.registerForm2.setControl("level", new FormControl(this.level));
    if (this.level == 0)
      this.units.getAllUnits(this.company_id).subscribe((response: any) => {
        let units = response.vehicles;
        this.selectedUnit = units.find((c) => c.id === this.entity_id);
        console.log("selectedUnit", this.selectedUnit, response);
      });
    this.traslateService.UserAlarmEventdataQuote.subscribe((data) => {
      this.urlC = data;
    });
    for (let entry of this.url) {
      this.id = entry.id;
      this.first_name = entry.first_name;
      this.last_name = entry.last_name;
      this.gsm = entry.gsm_number;
      this.email = entry.email;
    }
    this.firstFormGroup = this._formBuilder.group({
      firstCtrl: ["", Validators.required],
    });
    this.secondFormGroup = this._formBuilder.group({
      secondCtrl: ["", Validators.required],
    });
    this.getContactSelect();
  }

  registerForm2: FormGroup = this.formBuilder.group({
    // tslint:disable-next-line:quotemar
    acceleration: ["", Validators.compose([Validators.max(100)])],
    braking: ["", Validators.compose([Validators.max(100)])],
    company: [],
    company_id: [],
    created_at: [],
    created_by: [],
    id: [],
    lane_crossing: ["", Validators.compose([Validators.max(100)])],
    period: [],
    speeding: ["", Validators.compose([Validators.max(100)])],
    turn: ["", Validators.compose([Validators.max(100)])],
    turn_and_accelerate: ["", Validators.compose([Validators.max(100)])],
    turn_and_brake: ["", Validators.compose([Validators.max(100)])],
    type: [],
    updated_at: [],
    contacts: [],
    entity_id: [],
  });

  registerFormContact: FormGroup = this.formBuilder.group({
    // tslint:disable-next-line:quotemar
    // tslint:disable-next-line:quotemar
    last_name: [
      "",
      {
        validators: [
          Validators.required,
          Validators.pattern(/^[a-zA-Z][a-zA-Z\s]+$/),
        ],
        updateOn: "change",
      },
    ],
    email: [
      "",
      {
        validators: [Validators.required, Validators.email],
        updateOn: "change",
      },
    ],

    gsm_number: [],
    first_name: [
      "",
      {
        validators: [
          Validators.required,
          Validators.pattern(/^[a-zA-Z][a-zA-Z\s]+$/),
        ],
        updateOn: "change",
      },
    ],
    company_id: [],
    created_at: [],
    created_by: [],
    id: [],
    updated_at: [],
  });

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  add_contact() {
    this.new_contact = !this.new_contact;
  }

  select_contact() {
    this.new_contact = false;
  }

  submitcontact() {
    Object.values(this.registerFormContact).forEach((val) => {
      console.log(val);
    });
    this.submitStatus = true;
    this.http
      .post(
        environment.apiUrl +
          "/companies/" +
          JSON.parse(localStorage.getItem("currentUser")).company_id +
          "/contacts/all",
        this.registerFormContact.value
      )
      .subscribe(
        (data) => {
          var statuscontact: any = data;
          console.log(data);
          if (statuscontact.status == 200) {
            Swal.fire({
              position: "center",
              title: "Contact ajouté avec succées !",
              showConfirmButton: false,
              timer: 4000,
            });
            this.getContactSelect();
          } else {
            console.log("500 status");
            Swal.fire({
              text: statuscontact.response + "!",
            });
          }
        },
        (error) => {
          Swal.fire({
            text: "Un problème est survenu! " + error,
          });
        }
      );
    //location.reload()
  }

  Delete_contact(e) {
    console.log(e);

    this.getContact_notif();
    localStorage.removeItem("contact1");
    this.contact_notif.splice(e, 1);
    this.contact_notif2.splice(e, 1);

    console.log(this.contact_notif);

    console.log(this.contact_notif2);

    localStorage.setItem("contact1", this.contact_notif2);

    var ids = localStorage.getItem("contact1");
    console.log(ids);
    // tslint:disable-next-line:member-ordering

    var ids2 = ids.split(",");
    console.log(ids2);
    console.log(this.formBuilder.array(ids2));

    this.registerForm2.setControl(
      "contacts",
      new FormControl(JSON.stringify(ids2))
    );
  }

  submitFormupdate() {
    Object.values(this.registerForm2).forEach((val) => {
      console.log(val);
    });
    this.submitStatus = true;
    this.http
      .put(environment.apiUrl + "/alarms/" + this.id, this.registerForm2.value)
      .subscribe(
        (data) => {
          var status: any = data;
          if (status.status == 200) {
            Swal.fire({
              position: "center",
              title: "Modification enregistrée avec succées !",
              allowOutsideClick: false,
              showConfirmButton: false,
              timer: 1000,
            });
            location.reload();
            localStorage.removeItem("contact1");
          } else {
            console.log("500 status");
            Swal.fire({
              text: status.response + "!",
            });
          }
        },
        (error) => {
          Swal.fire({
            text: "Un problème est survenu! " + error,
          });
        }
      );
  }

  click() {
    this.compagnie = this.compagnie.name;
  }

  enableacceleration() {
    this.accelerationinput = !this.accelerationinput;
  }

  enablevirage() {
    this.virageinput = !this.virageinput;
  }

  enablevir_frein() {
    this.vir_frein_input = !this.vir_frein_input;
  }

  enableexcesvitesse() {
    this.excesvitesseinput = !this.excesvitesseinput;
  }

  Freinage() {
    this.freinage_input = !this.freinage_input;
  }

  enable_F() {
    this.freinage_input = !this.freinage_input;
  }

  enable_vir_acceleration() {
    this.vir_accelerationinput = !this.vir_accelerationinput;
    console.log(this.vir_accelerationinput);
  }

  enable_franch_de_ligne() {
    this.franch_de_ligne_input = !this.franch_de_ligne_input;
  }

  enablehors_piste() {
    this.hors_pisteinput = !this.hors_pisteinput;
  }

  enablebosse() {
    this.bosseinput = !this.bosseinput;
  }

  alarm_active_tranches() {
    this.alarmtranche = true;
  }

  alarm_tjrs_active() {
    this.alarmtranche = false;
  }

  onNoClick(): void {
    this.dialogRef.close();
    localStorage.removeItem("contact1");
  }
}
